export const command = {
  name: 'selectAllCells',
  callback(_ref) {
    let {
      selection
    } = _ref;
    selection.markSource('keyboard');
    selection.selectAll(true, true, {
      disableHeadersHighlight: true
    });
    selection.markEndSource();
  }
};